import { render, staticRenderFns } from "./TrToolboxTool.vue?vue&type=template&id=67668194&scoped=true&"
import script from "./TrToolboxTool.vue?vue&type=script&lang=js&"
export * from "./TrToolboxTool.vue?vue&type=script&lang=js&"
import style0 from "./TrToolboxTool.vue?vue&type=style&index=0&id=67668194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67668194",
  null
  
)

export default component.exports